<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>短信</li>
                <li><a href="#">收短信-通知设置</a></li>
            </ul>
        </div>
    
        <div class="mainindex">
            <div class="welinfo">
                <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                <b>短信到达通知功能说明: </b>
            </div>
    
            <ul class="infolist">
                <li><span>当你的短信发出，收件箱有回复时，第一时间知道的方法：</span></li>
                <li><span>（1）短信弹屏：您电脑在线时即时提醒 </span></li>
                <li><span>（2）离线短信转发：马上把内容通过短信告诉你的手机 0.1元/条 </span></li>
                <li><span>（3）振铃通知：我们会通过一个固定号码来让你的手机振动2－3声，告诉你有短信，请查看。 </span></li>
            </ul>
        
            <div class="xline"></div>
            <div class="box"></div>
        
            <div class="welinfo">
                <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                <b>离线短信转发 配置说明: </b>
            </div>
        
            <ul class="infolist_plb">
                <li class=" lh33"><span>对方的回复短信在放入收件箱的同时，也可以自动转发到你设定的手机上，这样你就不用守在电脑旁刷屏了。0.1元/条 </span></li>
                <li class=" lh33"><span>如果对方已经在你的通信录里，你将更方便的看到他的大名......快来把他们导入通信录吧 </span></li>
                <ul style="height:72px;">                    
                    <li style="margin-right:15px;"><label style="padding-right:10px; line-height:32px;">接收离线短信转发手机号码</label><input name="" type="text" v-model="phoneNum" class="scinput" style="width:150px;"/></li>
                    <li style=" margin-right:15px;"><label style="padding-right:10px; line-height:32px;">是否开启接收离线短信转发</label><input name="" type="checkbox" value="" v-model="isStart" style=" margin-top:10px;" /></li>
                </ul>
                <li><div class="xline"></div><div class="box"></div></li>
                <li><input class="sure" type="button" @click="updSmsReachNotice('sms')" value="提交" style=" margin-left:15%;">&nbsp;
                    <input class="cancel" type="button" value="重置">
                </li>
            </ul>
        
            <div class="box"></div>
            <div class="xline"></div>
            <div class="box"></div>
        
            <!-- <div class="welinfo">
                <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                <b>短信到达振铃通知 说明: </b>
            </div>
        
            <ul class="infolist_plb">
                <li class=" lh33"><span>对方的回复短信在放入收件箱的同时,振铃通知你的手机号码:手机振动2－3声，告诉你有短信，请查看。 通知号码：057156898222（不定期调整） 请把通知号码保存在你手机上,名称为"二办信使"  </span></li>
                <li class=" lh33"><span>如果对方已经在你的通信录里，你将更方便的看到他的大名......快来把他们导入通信录吧 </span></li>
                <ul style="height:72px;">
                    
                    <li style="margin-right:15px;"><label>短信到达振铃号码&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label><input name="" type="text" v-model="smsPhoneNum" class="scinput" style="width:150px;"/></li>
                    <li style="margin-right:15px;"><label>是否开启短信到达振铃通知 </label><input name="" type="checkbox" value="" v-model="pisStart" style=" margin-top:10px;" /></li>
                </ul>
                <li><div class="xline"></div><div class="box"></div></li>
                <li><input class="sure" type="button" value="提交" @click="updSmsReachNotice('phone')" style=" margin-left:15%;">&nbsp;
                    <input class="cancel" type="button" value="重置">
                </li>
            </ul>
        
            <div class="box"></div>
            <div class="xline"></div>
            <div class="box"></div> -->
        
            <div class="mainindex">
                <div class="welinfo">
                    <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                    <b>短信功能说明: </b>
                </div>
                <ul class="infolist">
                    <li><span>短信弹屏功能推出试用：</span></li>
                    <li><span>只要你停留在云验证短信功能的任一网页上，当有回复短信到达时，会自动弹出一个窗口提醒你短信到达。第一时间掌握商机信息 </span></li>
                    <li><span>短信群收 推出 </span></li>
                    <li><span>手机短信收不停，转摘、回复太麻烦了！如何解决短信群发之后的群收问题？ </span></li>
                    <li><span>现在，你只需对外公布一个固定的短信接收号，对应的内容格式，我们就可以把批量短信快速群收下来转递给你，你再数据稍微整理，就可快速的获得报名、数据采集、统计报表。方便快捷便宜（暂时免费） 
                </span></li>
                    <li><span>使用方法：</span></li>
                    <li><span>发 "门牌号#内容 " 到 1373 8090 222 或 (021 5212 9052(暂停)) 注意门牌号后面要跟#, 如手机号A发送短信"20582#老钱我报名" ，则门牌号20582会收到 A号码"老钱我报名"</span></li>
                    <li><span>例如：我的门牌号是20582，要每天统计汇报，则请对方 发送短信格式如下：</span></li>
                    <li><span>发" 20582#报告：商务客饮料卖完啦，云验证还有2间。。。。" 到 1373 8090 222或 021 5212 9052 你就可以在你的短信宝收信箱快速收到啦 </span></li>
                    <li><span>支持二次开发接口，有专业、个性需求的请联络我们，欢迎意见建议。</span></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            phoneNum:'',
            smsPhoneNum:'',
            isStart:false,
            pisStart:false
        }
    },
    mounted(){
        this.getData();
    },
    methods:{
        getData(){
            let that = this;
            let data = {}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/smsreachnotice.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    if(null != res.data.smsReachNotice)
                    {
                        that.phoneNum = res.data.smsReachNotice.phoneNum;
                        if(1 == res.data.smsReachNotice.isStart)
                        {
                            that.isStart = true;
                        }
                        
                    }
                    if(null != res.data.smsReachNoticePhone)
                    {
                        that.smsPhoneNum = res.data.smsReachNoticePhone.phoneNum;
                        if(1 == res.data.smsReachNoticePhone.isStart)
                        {
                            that.pisStart = true;
                        }
                    } 
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        updSmsReachNotice(type){
            let that = this;
            let data = {};
            if('sms' == type){
                data = {'phoneNum':this.phoneNum,'isStart':this.isStart ? 1 : 0,'type':'sms'};
            }
            else if('phone' == type){
                data = {'phoneNum':this.smsPhoneNum,'isStart':this.pisStart ? 1 : 0,'type':'phone'};
            }
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/updsmsreachnotice.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert('修改成功！')
                    that.getData(); 
                }
                else
                {
                    alert(res.data.msg)
                }
            })

        },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/sms/smsreachnotice.vue